import { useEffect, useRef, useState } from "react";
import { createBuyFlow } from "./buy-flow";
import type { BuyFlowDeps, BuyFlowState } from "./buy-flow.types";

export function useBuyFlow(deps: BuyFlowDeps, challengeToken: string) {
  const [state, setState] = useState<BuyFlowState>({ kind: "idle" });
  const [flow] = useState(() => createBuyFlow(deps, setState));
  const activeTokenRef = useRef<string | null>(null);
  const cleanupRef = useRef({ superseded: true });

  useEffect(() => {
    cleanupRef.current.superseded = true;
    const cleanup = { superseded: false };
    cleanupRef.current = cleanup;
    if (activeTokenRef.current !== challengeToken) {
      if (activeTokenRef.current !== null) {
        flow.cancel();
      }
      activeTokenRef.current = challengeToken;
      void flow.start(challengeToken);
    }
    return () => {
      queueMicrotask(() => {
        if (cleanup.superseded) {
          return;
        }
        flow.cancel();
      });
    };
  }, [flow, challengeToken]);

  return { state, flow };
}
